import * as React from "react";

export interface LabelProps {
  readonly children?: React.ReactNode;
}

export function Label({ children }: LabelProps): JSX.Element {
  return <span className="ml-1 mr-1">{children}</span>;
}
